import { assign, get, isArray } from 'lodash';
import { updateArrayItemByID, removeArrayItemByID } from 'utils/array';
import * as api from 'api/api-personal';
import * as types from '../mutation-types';

const initState = {
  ready: false,
  fetching: false,
  fetched: true,
  saving: false,
  saveError: null,
  error: null,
  notFound: null,
  meta: {},
  data: [],
};

const neutralState = {
  fetching: false,
  fetched: true,
  saving: false,
  saveError: null,
  error: null,
  notFound: null,
};

const state = assign({}, initState);

const getters = {
  PersonalBiography: state => state,
};

const actions = {
  GetPersonalBiography({ commit }) {
    commit(types.FETCH_PERSONAL_BIOGRAPHY_START);
    api.getPersonalBiography(
      (response) => {
        commit(types.RECEIVE_PERSONAL_BIOGRAPHY, { response });
      },
      (error, status, saveError) => {
        commit(types.FETCH_PERSONAL_BIOGRAPHY_ERROR, { saveError });
      },
    );
  },
  ClearPersonalBiography({ commit }) {
    commit(types.CLEAR_PERSONAL_BIOGRAPHY_STORE);
  },

  AddProfessionalExperienceInBiography({ commit }, { response }) {
    commit(types.ADD_PROFESSIONAL_EXPERIENCE_IN_BIOGRAPHY, { response });
  },
  UpdateProfessionalExperienceInBiography({ commit }, { response }) {
    commit(types.UPDATE_PROFESSIONAL_EXPERIENCE_IN_BIOGRAPHY, { response });
  },
  RemoveProfessionalExperienceFromBiography({ commit }, { id }) {
    commit(types.REMOVE_PROFESSIONAL_EXPERIENCE_FROM_BIOGRAPHY, { id });
  },

  AddPersonalEducationInBiography({ commit }, { response }) {
    commit(types.ADD_PERSONAL_EDUCATION_IN_BIOGRAPHY, { response });
  },
  UpdatePersonalEducationInBiography({ commit }, { response }) {
    commit(types.UPDATE_PERSONAL_EDUCATION_IN_BIOGRAPHY, { response });
  },
  RemovePersonalEducationFromBiography({ commit }, { id }) {
    commit(types.REMOVE_PERSONAL_EDUCATION_FROM_BIOGRAPHY, { id });
  },
};

const mutations = {
  [types.FETCH_PERSONAL_BIOGRAPHY_START](state) {
    assign(state, neutralState, { fetching: true });
  },
  [types.FETCH_PERSONAL_BIOGRAPHY_ERROR](state, { saveError }) {
    assign(state, neutralState, { saveError });
  },
  [types.RECEIVE_PERSONAL_BIOGRAPHY](state, { response }) {
    assign(state, neutralState, { ready: true, data: response.data, meta: response.meta });
  },

  [types.CLEAR_PERSONAL_BIOGRAPHY_STORE](state) {
    assign(state, initState);
  },

  [types.ADD_PROFESSIONAL_EXPERIENCE_IN_BIOGRAPHY](state, { response }) {
    const personExperience = get(state, 'data.PersonExperience', null);
    if (isArray(personExperience)) personExperience.push(response.data);
  },
  [types.UPDATE_PROFESSIONAL_EXPERIENCE_IN_BIOGRAPHY](state, { response }) {
    const personExperience = get(state, 'data.PersonExperience', null);
    if (isArray(personExperience)) updateArrayItemByID(personExperience, response.data);
  },
  [types.REMOVE_PROFESSIONAL_EXPERIENCE_FROM_BIOGRAPHY](state, { id }) {
    const personExperience = get(state, 'data.PersonExperience', null);
    if (isArray(personExperience)) removeArrayItemByID(personExperience, id);
  },

  [types.ADD_PERSONAL_EDUCATION_IN_BIOGRAPHY](state, { response }) {
    const personEducation = get(state, 'data.PersonEducation', null);
    if (isArray(personEducation)) personEducation.push(response.data);
  },
  [types.UPDATE_PERSONAL_EDUCATION_IN_BIOGRAPHY](state, { response }) {
    const personEducation = get(state, 'data.PersonEducation', null);
    if (isArray(personEducation)) updateArrayItemByID(personEducation, response.data);
  },
  [types.REMOVE_PERSONAL_EDUCATION_FROM_BIOGRAPHY](state, { id }) {
    console.log('REMOVE_PERSONAL_EDUCATION_FROM_BIOGRAPHY', id);
    const personEducation = get(state, 'data.PersonEducation', null);
    if (isArray(personEducation)) removeArrayItemByID(personEducation, id);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/personal/entities/personal-biography.js